<template>
  <BaseCenteredModal
    :is-modal-open="open"
    size="large"
    click-outside-close
    @update:is-modal-open="$emit('update:open', $event)"
  >
    <template #subtitle>
      <div class="flex flex-col gap-0.5">
        <div class="flex items-center gap-2">
          <FontAwesomeIcon :icon="['fal', 'folder']" class="text-gray-500" />
          <span>{{ dossierReference ?? $t('attributes.dossier') }}</span>
        </div>
        <div
          v-if="localResponsable"
          class="flex items-center gap-2 text-sm font-normal text-gray-500 dark:text-gray-400"
        >
          <FontAwesomeIcon :icon="['fal', 'user-tie']" class="text-gray-400" />
          <span>{{ localResponsable.full_name }}</span>
        </div>
      </div>
    </template>
    <template #header>
      <RouterLink
        v-if="dossierId"
        :to="{
          name: 'dossier_form_edit_route',
          params: { id: dossierId }
        }"
        class="flex items-center gap-1.5 rounded-md border px-2 py-1 text-sm font-medium hover:bg-gray-50 dark:hover:bg-slate-600"
        @click="$emit('update:open', false)"
      >
        <FontAwesomeIcon :icon="['fal', 'external-link']" />
        {{ $t('global.dossier') }}
      </RouterLink>
    </template>
    <template #body>
      <div class="w-full">
        <DossierConsultContent v-if="open" :dossier-id="dossierId" @loaded="onDossierLoaded" />
      </div>
    </template>
  </BaseCenteredModal>
</template>

<script>
import BaseCenteredModal from '@c/addf-package/components/modal/BaseCenteredModal.vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import DossierConsultContent from '@c/dossier/DossierConsultContent.vue'

export default {
  name: 'PlanningDossierConsultModal',
  components: { BaseCenteredModal, FontAwesomeIcon, DossierConsultContent },
  props: {
    open: {
      type: Boolean,
      required: true
    },
    dossierId: {
      type: [String, Number],
      required: true
    },
    dossierReference: {
      type: String,
      required: false,
      default: null
    }
  },
  emits: ['update:open'],
  data() {
    return {
      localResponsable: null
    }
  },
  watch: {
    open(newVal) {
      if (!newVal) {
        this.localResponsable = null
      }
    }
  },
  methods: {
    onDossierLoaded(dossier) {
      this.localResponsable = dossier?.responsable ?? null
    }
  }
}
</script>
